import React from 'react';
import LocationProfileCard from './LocationProfileCard';
import {Grid} from '@mui/material';
import RecentlyBookedCarouselSkeleton from '../../../skeleton/RecentlyBookedCarouselSkeleton';
import SwiperCarousel from '../features/SwiperCarousel';
import {SwiperSlide} from "swiper/react";
import {styled} from "@mui/material/styles";

const LocationProfileCardContainer = styled(Grid)(() => ({
    '&&': { // force these styles to take precedence over ss-recent-booked-locations
        overflowX: 'auto',
        paddingBottom: '1rem', // To make bottom shadow appear better
    }
}));

const LocationProfileCardSwiperSlide = styled(SwiperSlide)(() => ({
    '&&': { // force styles to override SwiperSlide defaults
        background: '#FFFFFF',
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.05)',
        borderRadius: '.4em',
        width: '20em'
    }
}));

const LocationProfileCardList = (props) => {
    const { locations, loading } = props;

    return (
        <LocationProfileCardContainer
            container
            className='ss-recent-booked-locations'
        >
            <SwiperCarousel isNextDisabled={true}>
                {loading ? [...Array(4).keys()].map((_, index) => <LocationProfileCardSwiperSlide key={index}>
                    <RecentlyBookedCarouselSkeleton />
                </LocationProfileCardSwiperSlide>) : locations?.map((location) => (
                    <LocationProfileCardSwiperSlide key={location?.locationId}>
                        <LocationProfileCard
                            key={location.locationId}
                            listingImageFileName={location.listingImageFileName}
                            pricePerDay={location.pricePerDay}
                            pricePerMonth={location.pricePerMonth}
                            instantApproval={location.hasInstantApproval}
                            locationName={location.locationName}
                            cityName={location.city}
                            distanceTo={location.distance}
                            id={location.locationId}
                        />
                    </LocationProfileCardSwiperSlide>
                ))}
            </SwiperCarousel>
        </LocationProfileCardContainer>
    );
};

export default LocationProfileCardList;
